module.exports = __webpack_public_path__ + "media/src/images/styleguide/chocolate-05c982648d23f52e7d41e490199ed41f.svg";